//行政月常规采购验收
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
			<SelectFilterTable v-if='item.Property.Control=="SelectFilterTable"' @data-val='item' :template-data='templateData.TemplateContent.Controls'
		 :val-index='5'></SelectFilterTable>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import SelectFilterTable from '../components/SelectFilterTable.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";

	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		getFlowTemplate,
		GetPendingProcessById,
		getAdministrativeProgressive,
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			SelectFilterTable
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				applyTemplateData:null,
				flowId:null
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation(this.logInfo.EmpNo);
			stringUtils.setAddIsShow(true);
		},
		
		methods: { //方法
			
			clickChoose: async function(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},
			getTemplate:async function() {
				
				await GetPendingProcessById(this.flowId).then(response =>{
					if(response.Body==null){
						this.Message({
							message: '该流程已经处理完成',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/Pricing");
						}, 1000)
						return;
					}
				})
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				await this.getFlowTemplateInfo();
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					console.log(controls);
					controls.TemplateContent.Controls.forEach(async (item) => {
						var departs = this.logInfo.fullName.split("/");
						if(this.applyTemplateData!=null){
							var data = this.applyTemplateData.TemplateContent.Controls.filter(t=>{ return t.Property.Title[0].Text == item.Property.Title[0].Text});
							if (item.Property.Title[0].Text == "申请部门") {
								if(data!=null){
									item.Disable = true;
									item.Value=data[0].Value;
									item.Disable = true;
								}
							}
							if (item.Property.Title[0].Text == "申请人部门") {
								data = this.applyTemplateData.TemplateContent.Controls.filter(t=>{ return t.Property.Title[0].Text == "部门"});
								if(data!=null){
									item.Value=data[0].Value;
									item.Disable = true;
								}
							}
							if (item.Property.Title[0].Text == "实际购买是否与请购内容相符") {
								console.log(item);
								item.Value = "option-1601016187529"
							}
							if (item.Property.Title[0].Text == "申请内容") {
								item.Config.Table.Children.forEach((data) => {
									data.Disable = true;
								});
							}
							if (item.Property.Title[0].Text == "小战区区董") {
								item.IsShow = false;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
							if (item.Property.Title[0].Text == "行政主任") {
								item.IsShow = false;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
							if (item.Property.Title[0].Text == "大战区区董") {
								item.IsShow = false;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
							if (item.Property.Title[0].Text == "部门负责人") {
								item.IsShow = false;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
							if (item.Property.Title[0].Text == "区域总经理") {
								item.IsShow = false;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
							if (item.Property.Title[0].Text == "流程部门") {
								item.IsShow = false;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
							
							if (item.Property.Title[0].Text == "联系人电话") {
								item.Disable = true;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
							if (item.Property.Title[0].Text == "备注") {
								item.Disable = true;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
							if (item.Property.Title[0].Text == "附件") {
								item.Disable = true;
								if(data!=null){
									item=data[0];
								}
							}
							if(item.Property.Title[0].Text == "关联申请单"){
								item.Value = this.spNo;
							}
							
						
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo, this.flowId,true);
					this.listLoading = false;
					controls.TemplateContent.Controls.forEach(async (item) => {
						var departs = this.logInfo.fullName.split("/");
						if(this.applyTemplateData!=null){
							var data = this.applyTemplateData.TemplateContent.Controls.filter(t=>{ return t.Property.Title[0].Text == item.Property.Title[0].Text});
							if (item.Property.Title[0].Text == "流程部门") {
								item.IsShow = false;
								if(data!=null){
									item.Values=data[0].Values;
									item.Value=data[0].Value;
								}
							}
						}
					});
					
				});
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getFlowTemplateInfo: async function() {
				if(this.flowId==null||this.flowId==undefined||this.flowId.length<=0){
						return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				if(name == "实际购买是否与请购内容相符"){
					if(val == "option-1601016187529"){
						this.templateData.TemplateContent.Controls.forEach((item) => {
							if (item.Property.Title[0].Text.indexOf("申请内容") > -1) {
								item.addIsShow = false;
								item.Config.Table.Children.forEach((data) => {
									data.Disable = true;
								});
							}
							// if (item.Property.Title[0].Text == "实际购买是否与请购内容相符") {
							// 	console.log(item);
							// }
						});
					}else{
						this.templateData.TemplateContent.Controls.forEach((item) => {
							
							if (item.Property.Title[0].Text.indexOf("申请内容") > -1 ) {
								item.addIsShow = true;
								item.Config.Table.Children.forEach(async (sonData) => {
									sonData.Disable = false;
									var valueData = sonData.Value;
									//    sonData.Value = "";
									if (sonData.Property.Title[0].Text == "种类") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
										this.$set(sonData,'Options',[]);
										await getAdministrativeProgressive("", "", "", "", "", "").then(res => {
											res.Body.forEach(val => {
												var data = {
													"Key": val,
													"Value": val
												};
												sonData.Options.push(data);
											});
										});
										console.log(sonData);
									}
									if (sonData.Property.Title[0].Text == "物品名称") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
									if (sonData.Property.Title[0].Text == "规格型号") {
										this.$set(sonData,'Options',[]);
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
							
									}
									if (sonData.Property.Title[0].Text == "单位") {
										this.$set(sonData,'Options',[]);
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
							
									}
									if (sonData.Property.Title[0].Text == "单价") {
										this.$set(sonData,'Options',[]);
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
								});
							}
						});
					}
				}
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit: async function() {
					var that = this;
					var IsReturn = false;
					for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
						var item = this.templateData.TemplateContent.Controls[i];
						if (item.Property.Title[0].Text.indexOf("申请内容") > -1) {
							var type = "";
							var ItemName = "";
							var SpecificationModel = "";
							var Company = "";
							var UnitPrice = "";
							item.Config.Table.Children.forEach((sonData) => {
								if (sonData.Property.Title[0].Text == "种类") {
									type = sonData.Value;
								}
								if (sonData.Property.Title[0].Text == "物品名称") {
									ItemName = sonData.Value;
								}
								if (sonData.Property.Title[0].Text == "规格型号") {
									SpecificationModel = sonData.Value;
								}
								if (sonData.Property.Title[0].Text == "单位") {
									Company = sonData.Value;
								}
								if (sonData.Property.Title[0].Text == "单价") {
									UnitPrice = sonData.Value;
								}
							});
							await getAdministrativeProgressive(type, ItemName, SpecificationModel, Company, UnitPrice, 6).then(res => {
								if (res.Body.length == 0) {
									IsReturn = true;
									that.Message({
										message: '申请内容数据校验失败',
										type: 'error',
										duration: 3 * 1000
									});
								}
							});
						}
					}
					if (IsReturn) {
						return;
					}
					await this.templateData.TemplateContent.Controls.forEach((item) => {
						if (item.Property.Title[0].Text.indexOf("申请内容") > -1) {
							item.Config.Table.Children.forEach((sonData) => {
								if (sonData.Property.Title[0].Text == "种类") {
									sonData.Property.Control = "Text";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "物品名称") {
									sonData.Property.Control = "Text";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "规格型号") {
									sonData.Property.Control = "Text";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单位") {
									sonData.Property.Control = "Text";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单价") {
									sonData.Property.Control = "Money";
									sonData.filterable = true;
								}
							});
						}
					});
					
					//数据校验
					if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
						for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
							var item = this.templateData.TemplateContent.Controls[i];
							if (item.Property.Title[0].Text == "申请内容") {
								item.Config.Table.Children.forEach(async (sonData) => {
									if (sonData.Property.Title[0].Text == "种类") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
										sonData.Options = [];
										await getAdministrativeProgressive("", "", "", "", "", "").then(res => {
											res.Body.forEach(item => {
												var data = {
													"Key": item,
													"Value": item
												};
												sonData.Options.push(data);
											});
										});
			
									}
									if (sonData.Property.Title[0].Text == "物品名称") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
									if (sonData.Property.Title[0].Text == "规格型号") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
									if (sonData.Property.Title[0].Text == "单位") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
									if (sonData.Property.Title[0].Text == "单价") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
								});
							}
						}
						return;
					}
					if (isSubmit) {
						this.Message({
							message: '已提交',
							type: 'warning',
							duration: 1000
						});
						return;
					}
					isSubmit = true;
					this.listLoading = true;
					var toUser = this.templateData.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == "工号"
								})[0].Value;
					console.log(JSON.stringify(this.templateData));
					//提交
					submitProcess(this.templateId, toUser, this.spNo, this.templateData, this.flowId).then(response => {
						this.Message({
							message: '申请成功',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/index");
						}, 3000)
					}).finally(() => {
						isSubmit = false;
						this.listLoading = false;
						for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
							var item = this.templateData.TemplateContent.Controls[i];
							if (item.Property.Title[0].Text == "申请内容") {
								item.Config.Table.Children.forEach(async (sonData) => {
									if (sonData.Property.Title[0].Text == "种类") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
										sonData.Options = [];
										await getAdministrativeProgressive("", "", "", "", "", "").then(res => {
											res.Body.forEach(item => {
												var data = {
													"Key": item,
													"Value": item
												};
												sonData.Options.push(data);
											});
										});
			
									}
									if (sonData.Property.Title[0].Text == "物品名称") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
									if (sonData.Property.Title[0].Text == "规格型号") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
									if (sonData.Property.Title[0].Text == "单位") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
									if (sonData.Property.Title[0].Text == "单价") {
										sonData.Property.Control = "SelectFilterTable";
										sonData.filterable = true;
									}
								});
							}
						}
					});
				
				}
			},
			watch: {
				relationList(val, oldVal) {
					if (oldVal == null) {
						this.getTemplate();
					}
				}
			}
		// 	submit() {
		// 		//数据校验
		// 		if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
		// 			return;
		// 		}
		// 		if (isSubmit) {
		// 			this.Message({
		// 				message: '已提交',
		// 				type: 'warning',
		// 				duration: 1000
		// 			});
		// 			return;
		// 		}
		// 		isSubmit = true;
		// 		this.listLoading = true;
		// 		var toUser = this.templateData.TemplateContent.Controls.filter(t => {
		// 						return t.Property.Title[0].Text == "工号"
		// 					})[0].Value;
		// 		//提交
		// 		console.log(JSON.stringify(this.templateData.TemplateContent.Controls));
		// 		submitProcess(this.templateId, toUser, this.spNo, this.templateData, this.flowId).then(response => {
		// 			this.Message({
		// 				message: '申请成功',
		// 				type: 'success',
		// 				duration: 3 * 1000
		// 			});
		// 			setTimeout(() => {
		// 				this.$router.push("/index");
		// 			}, 3000)
		// 		}).finally(() => {
		// 			isSubmit = false;
		// 			this.listLoading = false;
		// 		});
		// 	}
		// },
		// watch: {
		// 	relationList(val, oldVal) {
		// 		if (oldVal == null) {
		// 			this.getTemplate();
		// 		}
		// 	}
		// }
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
